
import 'dropify';

$(function () {
  "use strict";
  $('.dropify').dropify();
});
